// This was generated during the migration to @kiwicom/eslint-config
// PLEASE REMOVE THE GLOBAL ESLINT DISABLE BELOW
// AND FIX ERRORS ACCORDINGLY.
/* eslint-disable default-param-last */
// @ts-expect-error: Flow to TS migration.
import type { Route } from "react-router-config"

export function updateRoute(
  params: // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  | {
        [key: string]: string | null | undefined
      }
    | null
    | undefined = {},
  routes: Route[] | null | undefined = [],
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/consistent-indexed-object-style
  query: {
    [key: string]: string
  },
) {
  return {
    type: "UPDATE_ROUTE",
    params,
    // @ts-expect-error: Flow to TS migration.
    pageName: routes[routes.length - 1]?.name,
    // @ts-expect-error: Flow to TS migration.
    pageNamesPath: routes
      .map((route) => route.name)
      .filter(Boolean)
      .join("/"),
    query,
  }
}
